(function () {
  // 设计稿尺寸及其对应的基准字体大小
  var designWidths = [
    { width: 375, fontSize: 100 },
    { width: 834, fontSize: 100 },
  ];

  // 动态计算或固定HTML字体大小的函数
  function setHtmlFontSize(deviceWidth) {
    // 当屏幕宽度大于等于1200px时，固定HTML字体大小为100px
    if (deviceWidth >= 1200) {
      document.documentElement.style.fontSize = '100px';
    } else {
      // 根据设备宽度找到最佳匹配的设计稿尺寸
      var bestMatch = designWidths.reduce((prev, current) => {
        return deviceWidth < 768 ? prev : current;
      });

      // 计算并设置REM基准值
      var htmlFontSize = (deviceWidth / bestMatch.width) * bestMatch.fontSize;
      document.documentElement.style.fontSize = htmlFontSize + 'px';
    }
  }

  // 初始化HTML字体大小
  var deviceWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  setHtmlFontSize(deviceWidth);

  // 添加resize事件监听器，当窗口大小变化时重新设置REM基准值
  window.addEventListener('resize', function () {
    deviceWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    setHtmlFontSize(deviceWidth);
  });
})();
